import {
	Injector,
	NgModule,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { COMMON_APP_CONFIG } from '../../../Common/app/app.config.token';
import { LOCALE_TRANSLATIONS } from '../../../Common/services/locale/locale.translations.token';
import { LOCAL_APP_DATA_GETTER } from '../../../Common/services/app_data/local_app_data.token';
import { CommonAppModule } from '../../../Common/app/app.module';
import { CommonPrefixUrlInterceptor } from '../../../Common/interceptors/prefix_url_interceptor.service';
import { CommonXHRHeaderInterceptor } from '../../../Common/interceptors/xhr_header_interceptor';

import { AuthenticationMeetingsCommonModule } from './authentication.meetings.common.module';
import { AuthenticationMeetingsComponent } from './authentication.meetings.component';
import { authenticationMeetingsLocalAppDataGetter } from './authentication.meetings.local_app_data.getter';
import { authenticationMeetingsAppConfig } from './authentication.meetings_app.config';
import { AuthenticationMeetingsLoginComponent } from '../login/authentication.meetings.login.component';
import { authenticationMeetingsRoutes } from '../routes/router_config';
import { AuthenticationMeetingsUserService } from './services/authentication.meetings.user.service';
import { AuthenticationMeetingsErrorService } from './services/authentication.meetings.error.service';
import { AuthenticationMeetingsConfirmComponent } from '../confirm/authentication.meetings.confirm.component';
import { AuthenticationMeetingsRemindComponent } from '../remind/authentication.meetings.remind.component';
import { AuthenticationMeetingsChangePasswordComponent } from '../change_password/authentication.meetings.change_password.component';
import { AuthenticationMeetingsRegistrationComponent } from '../registration/authentication.meetings.registration.component';
import { AuthenticationMeetingsAuthRedirectInterceptor } from '../interceptors/authentication.meetings.auth_redirect_interceptor';
import { AuthenticationMeetingsLocaleTranslations } from './authtentication.meetings.locale.translations';

@NgModule({
    declarations: [
        AuthenticationMeetingsComponent,
        AuthenticationMeetingsLoginComponent,
        AuthenticationMeetingsConfirmComponent,
        AuthenticationMeetingsRegistrationComponent,
        AuthenticationMeetingsRemindComponent,
        AuthenticationMeetingsChangePasswordComponent,
    ],
    imports: [
        CommonAppModule,
        UIRouterModule.forRoot({
            otherwise: '/login',
            states: authenticationMeetingsRoutes,
            useHash: true,
        }),
        FormsModule,
        BrowserAnimationsModule,
        AuthenticationMeetingsCommonModule,
    ],
    providers: [
        {
            provide: COMMON_APP_CONFIG,
            useValue: authenticationMeetingsAppConfig,
        },
        {
            provide: LOCAL_APP_DATA_GETTER,
            useValue: authenticationMeetingsLocalAppDataGetter,
        },
        {
            provide: LOCALE_TRANSLATIONS,
            useValue: AuthenticationMeetingsLocaleTranslations,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CommonPrefixUrlInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CommonXHRHeaderInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationMeetingsAuthRedirectInterceptor,
            multi: true,
        },
        AuthenticationMeetingsUserService,
        AuthenticationMeetingsErrorService,
    ]
})
export class AuthenticationMeetingsModule extends CommonAppModule {
	constructor (
		protected injector: Injector,
	) {
		super(
			injector,
		);
	}
}
